.container {
  container-type: inline-size;
}

.composer {
  display: flex;
  flex-direction: column;
  gap: var(--zumpo-space-16);
}

/* Suggest and Done, or the notice and Keep editing, one over the other in
   the same place. */
.swap {
  display: grid;
}

.swap > .actions {
  grid-area: 1 / 1;
}

.held {
  visibility: hidden;
}

/* Suggest on the left, Done on the right. */
.actions {
  display: flex;
  align-items: center;
  gap: var(--zumpo-space-12);
}

.done {
  margin-left: auto;
}

.notice {
  flex: 1;
  min-width: 0;
}

/* On a phone the two buttons share the row, each on a line of its own where
   even that is too narrow; done, the notice keeps beside Keep editing, as
   under a drawing, with only its pencil, so the row stays as low as it can. */
@container (max-width: 560px) {
  .actions {
    flex-wrap: wrap;
  }

  .half,
  .done {
    flex: 1;
    margin-left: 0;
  }

  .doneActions {
    flex-wrap: nowrap;
  }
}
